var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Component } from './Component';
var ChildComponent = function (props) {
    var children = props.children;
    return (React.createElement(React.Fragment, null, children && children.length > 0
        ? children.map(function (itemProps, index) {
            return React.createElement(Component, __assign({ key: "" + index }, itemProps));
        })
        : null));
};
export default ChildComponent;
//# sourceMappingURL=ChildComponent.js.map